import { endPoints } from 'api/';
import { active } from 'constants/status';
import { GET_CATEGORIES } from 'actions/types';

/**
 * @description Get a list of all categories
 * @param {string} companyId Current user's company id.
 * @returns Array of category objects
 */
function query(companyId) {
  const query = {
    where: {
      status: active,
      company_id: companyId,
    },
  };
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: GET_CATEGORIES,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const category = await apiClient(endPoints.GET_CATEGORIES, {}, query);
        return category;
      },
    };
    dispatch(action);
  };
}

export default query;
